import { useState, useCallback } from 'react';
import '../../utils/assertions.es.js';
import { warn } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';

var useControlled = function useControlled(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      valueProp = _props.value,
      defaultValue = _props.defaultValue,
      onChange = _props.onChange;
  var isControlled = valueProp !== void 0;
  warn({
    condition: !isControlled && defaultValue === void 0,
    message: "useControlled: You need to add a default value when using an uncontrolled component"
  });

  var _useState = useState(defaultValue),
      valueState = _useState[0],
      setValue = _useState[1];

  var value = isControlled ? valueProp : valueState;
  var updateValue = useCallback(function (value2) {
    if (!isControlled) {
      setValue(value2);
    }

    onChange == null ? void 0 : onChange(value2);
  }, [isControlled, onChange]);
  return [value, updateValue];
};

export { useControlled };